// TODO: remove check the exports on commong and remove this when it is fixed
import { ImplementationBenefitsMethod } from '@finch-api/common/dist/db/index';
import { RegisterProviderContainerProps } from 'constants/types';
import SignInGuide from 'pages/Authorize/SignIn/SignInGuide';
import { AccountStatus } from '@finch-api/common/dist/external/dashboard/connection-status';
import { ProviderAppShell } from '../ProviderAppShell';
import { useSignInShellHeader } from 'store/sign-in-shell-header';

const RegisterProviderContainer = ({
  client,
  provider,
  products,
  connection,
  hasBenefitsProduct,
  currentStep,
  implementationDetail,
  children,
  sandboxMode,
  error,
  setError,
}: RegisterProviderContainerProps) => {
  const suppressConnectTitle = useSignInShellHeader(
    (state) => state.suppressConnectTitle,
  );
  const multiStepProviders = ['ulti_pro', 'ukg_ready', 'workday'];
  const isMultiStepFlow =
    multiStepProviders.includes(provider.id) &&
    implementationDetail.kind === 'api_token';

  const headerText =
    isMultiStepFlow || suppressConnectTitle
      ? undefined
      : `Connect your ${provider.displayName} account`;

  const eligibleForAssistedBenefits =
    // only eligible for assisted benefits if there's benefits product
    hasBenefitsProduct &&
    // only eligible for assisted benefits if provider supports assisted benefits
    implementationDetail.benefitsMethod ===
      ImplementationBenefitsMethod.ASSISTED &&
    // only eligible for assisted benefits if provider doesn't support accountant flow
    !implementationDetail.accountantSupported &&
    // only eligible when not in sandbox mode
    !sandboxMode &&
    // only eligible when connection's assisted status is not CONNECTED
    connection?.assistedStatus !== AccountStatus.CONNECTED;

  return (
    <ProviderAppShell
      error={error}
      setError={setError}
      providerImplementation={implementationDetail}
      provider={provider}
      headerText={headerText}
    >
      <SignInGuide
        client={client}
        products={products}
        provider={provider}
        currentStep={currentStep}
        enabled={eligibleForAssistedBenefits}
      >
        {children}
      </SignInGuide>
    </ProviderAppShell>
  );
};

export default RegisterProviderContainer;
